(function () {
  function getVisibleThumbnailButtons(wrapper) {
    return Array.from(
      wrapper.querySelectorAll(
        '[id^="GalleryThumbnails-"] .thumbnail-list__item button.thumbnail'
      )
    ).filter((btn) => btn.offsetParent !== null);
  }

  function getCurrentIndex(buttons) {
    const current = buttons.findIndex(
      (btn) => btn.getAttribute('aria-current') === 'true'
    );
    return current >= 0 ? current : 0;
  }

  function moveGallery(wrapper, direction) {
    if (!wrapper) return;

    const buttons = getVisibleThumbnailButtons(wrapper);
    if (!buttons.length) return;

    const currentIndex = getCurrentIndex(buttons);
    const nextIndex =
      (currentIndex + direction + buttons.length) % buttons.length;

    const target = buttons[nextIndex];
    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });

    target.click();
  }

  document.addEventListener('click', function (event) {
    const prev = event.target.closest('.custom-gallery-prev');
    const next = event.target.closest('.custom-gallery-next');

    if (!prev && !next) return;

    event.preventDefault();

    const wrapper = event.target.closest('.custom-product-gallery-wrapper');
    if (!wrapper) return;

    moveGallery(wrapper, prev ? -1 : 1);
  });

  // Helpful for Shopify pages that fully refresh or restore from cache
  window.addEventListener('pageshow', function () {
    // no-op on purpose; keeps delegated handler active after bfcache restores
  });
})();